import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // عام
      app_name: 'جَدوِل',
      loading: 'جارٍ التحميل...',
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      add: 'إضافة',
      search: 'بحث',
      back: 'رجوع',
      next: 'التالي',
      confirm: 'تأكيد',
      yes: 'نعم',
      no: 'لا',
      // تسجيل الدخول
      login: 'تسجيل الدخول',
      register: 'إنشاء حساب',
      logout: 'تسجيل الخروج',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      full_name: 'الاسم الكامل',
      phone: 'رقم الجوال',
      // الرئيسية
      home: 'الرئيسية',
      bookings: 'حجوزاتي',
      favorites: 'المفضلة',
      profile: 'حسابي',
      notifications: 'الإشعارات',
      // الحجز
      book_now: 'احجز الآن',
      select_service: 'اختر الخدمة',
      select_staff: 'اختر المختص',
      select_date: 'اختر التاريخ',
      select_time: 'اختر الوقت',
      booking_confirmed: 'تم تأكيد الحجز',
      // التاجر
      business_dashboard: 'لوحة التحكم',
      my_bookings: 'الحجوزات',
      services: 'الخدمات',
      staff: 'الموظفون',
      working_hours: 'أوقات العمل',
      business_profile: 'بيانات المكان',
      // المدير
      admin_dashboard: 'لوحة الإدارة',
      businesses: 'التجار',
      users: 'المستخدمون',
      categories: 'المجالات',
      ads: 'الإعلانات',
      // الحالات
      pending: 'قيد الانتظار',
      confirmed: 'مؤكد',
      completed: 'مكتمل',
      cancelled: 'ملغي',
      active: 'نشط',
      suspended: 'موقوف',
    }
  },
  en: {
    translation: {
      app_name: 'jadwil',
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      back: 'Back',
      next: 'Next',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      email: 'Email',
      password: 'Password',
      full_name: 'Full Name',
      phone: 'Phone',
      home: 'Home',
      bookings: 'Bookings',
      favorites: 'Favorites',
      profile: 'Profile',
      notifications: 'Notifications',
      book_now: 'Book Now',
      select_service: 'Select Service',
      select_staff: 'Select Staff',
      select_date: 'Select Date',
      select_time: 'Select Time',
      booking_confirmed: 'Booking Confirmed',
      business_dashboard: 'Dashboard',
      my_bookings: 'Bookings',
      services: 'Services',
      staff: 'Staff',
      working_hours: 'Working Hours',
      business_profile: 'Business Profile',
      admin_dashboard: 'Admin Dashboard',
      businesses: 'Businesses',
      users: 'Users',
      categories: 'Categories',
      ads: 'Ads',
      pending: 'Pending',
      confirmed: 'Confirmed',
      completed: 'Completed',
      cancelled: 'Cancelled',
      active: 'Active',
      suspended: 'Suspended',
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ar',
  fallbackLng: 'ar',
  interpolation: { escapeValue: false }
});

export default i18n;
